// Toast global: pesan melayang di bawah layar yang SELALU terlihat, di mana pun user
// sedang scroll. Latar belakang: tiap halaman merender pesan di bagian atas konten,
// padahal tombol aksinya sering jauh di bawah (form panjang, list channel) — di HP
// pesan error tidak pernah terlihat dan terasa "tombol tidak ada respon".
import axios from 'axios';

const listeners = new Set();
let seq = 0;
const recent = new Map(); // text -> timestamp, cegah dobel (interceptor + pesan halaman)

let lastServerErrorAt = 0; // kapan terakhir interceptor menampilkan pesan error dari server

export function showToast(text, type = 'info', ms = 6000) {
  if (!text) return;
  const now = Date.now();
  if (recent.get(text) && now - recent.get(text) < 1500) return;
  // Halaman sering ikut memanggil showMsg('Gagal ...') untuk request yang sama. Pesan server
  // lebih spesifik dan sudah tampil dari interceptor — jangan tumpuk dua toast error.
  if (type === 'error' && now - lastServerErrorAt < 1500) return;
  recent.set(text, now);
  const t = { id: ++seq, text: String(text), type, ms };
  listeners.forEach(fn => fn(t));
}

export function subscribeToast(fn) { listeners.add(fn); return () => listeners.delete(fn); }

// Jaring pengaman: setiap request TULIS (POST/PUT/PATCH/DELETE) yang gagal otomatis
// ditampilkan sebagai toast error, apa pun halamannya. GET (loader) tidak — biar tidak
// berisik. 401 diserahkan ke AuthContext (redirect login).
let installed = false;
export function installAxiosToast() {
  if (installed) return; installed = true;
  axios.interceptors.response.use(r => r, err => {
    const method = (err.config?.method || 'get').toLowerCase();
    const status = err.response?.status;
    if (method !== 'get' && status !== 401) {
      // Timeout ≠ server mati: request sudah jalan tapi kelamaan (biasanya upload file besar).
      if (!err.response && (err.code === 'ETIMEDOUT' || /timeout/i.test(err.message || '')))
        showToast('Upload terlalu lama dan dihentikan — coba koneksi yang lebih stabil atau perkecil ukuran video', 'error', 10000);
      else if (!err.response) showToast('Tidak bisa terhubung ke server — cek koneksi internet', 'error');
      else showToast(err.response.data?.error || err.response.data?.message || `Permintaan gagal (${status})`, 'error');
      lastServerErrorAt = Date.now();
    }
    return Promise.reject(err);
  });
}
